export default __webpack_public_path__ + "static/media/profitRadar.eee1db2f.avif";